export const REQUEST_CHECKLIST = 'zola/checklist/REQUEST_CHECKLIST';
export const RECEIVE_CHECKLIST = 'zola/checklist/RECEIVE_CHECKLIST';
export const RECEIVE_PRODUCT = 'zola/checklist/RECEIVE_PRODUCT';
